export const en = {
    'not-found': 'No results found',
    'not-selected': 'Nothing selected',
    'search-placeholder': 'Find segment or experiment',
    'segment-targeting-disabled': 'Targeting by segment is disabled',
    title: 'Targeting by segment'
};
